import OrderableModel from '@/models/OrderableModel';

export default class Priority extends OrderableModel {
    get route () {
        return 'priorities';
    }

    static get className () {
        return 'Priority';
    }

    static get isInStore () {
        return true;
    }
}
